import React from 'react';
import constClass from '../../Constants/Constants';
import Common from '../Common/common';
// import moment from 'moment';

const BenefitGrantList = ({ siteId, benefit_grantlist, benefitGrantClick, setting}) => {

  // const sysdate = new Date();
  // const sysdateTimestamp = sysdate.getTime();

  return (
    <div id="ticketList" className="ticket-list">
      {benefit_grantlist && benefit_grantlist.map(benefit =>
        <div key={`${benefit.benefit_id}-${benefit.issue_count}`} className="ticket-box">
          <div className="frame39">
            <div className="ticket-name">{benefit.benefit_title}</div>
            {/* {ticket.ticket_summary && <div className="ticket-summary">{ticket.ticket_summary}</div>} */}
          </div>
          <div className="frame42">
            {benefit.benefit_image_url && <img className="ticket-image" src={`/${siteId}/${constClass.BENEFIT_IMAGE_DIR}${benefit.benefit_image_url}`} alt={benefit.benefit_title} />}
            {!benefit.benefit_image_url && <img className="ticket-image" src={`/${siteId}/noimage.png`} alt="noimage" />}
            <div className='frame41'>
              <div className="ticket-detail">{Common.getBrString(benefit.benefit_summary)}</div>
              <button
                onClick={() => benefitGrantClick(benefit.issue_count, benefit.benefit_id)}
                className="button text-black bg-lightwhite">
                クーポンを表示する
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default BenefitGrantList;